(function (window, document, undefined) {

  window.blogsPagination = {

    init: () => {
      window.blogsPagination.displayPage(window.blogsPagination.getCurrentPageId());
      window.blogsPagination.displayPagination();
    },

    getCurrentPageId: () => {
      let currentUrl = window.location.href;
      if (currentUrl.indexOf('page=') !== -1) {
        let urlParams = new URLSearchParams(window.location.search);
        let pageValue = urlParams.get('page');
        return parseFloat(pageValue);
      } else {
        return 1;
      }
    },

    displayPage: (id) => {
      let items = document.querySelectorAll('.blog__posts [data-page]');
      if (items.length) {
        items.forEach((item) => {
          let data_page = parseFloat(item.getAttribute('data-page'));
          if (data_page == id) {
            item.classList.add('is_active');
          } else {
            item.classList.remove('is_active');
          }
        });
      }
    },

    displayPagination: () => {
      let blog_posts = document.querySelector('.blog__posts'), 
          blog_posts_li = document.querySelectorAll('.blog__posts [data-page]'), 
          data_items_number = parseFloat(blog_posts.getAttribute('data-items-number')),
          data_paginate_by = parseFloat(blog_posts.getAttribute('data-paginate-by')),
          current_page_number = window.blogsPagination.getCurrentPageId(),
          max_page_number = parseFloat(blog_posts_li[blog_posts_li.length - 1].getAttribute('data-page'));

      let dots = document.createElement('li');
      dots.classList.add('is_active');
      dots.innerHTML = '<span class="pagination__item">…</span>';

      if (data_items_number > data_paginate_by) {
        let pagination_items = document.querySelectorAll('[data-page-number]'),
            pagination_current_item = document.querySelector('[data-page-number="'+current_page_number+'"]');

        pagination_current_item.querySelector('a').classList.add('pagination__item--current');

        if (pagination_items.length >= 5) {

          let current_item_exist_in_first_5_items = false,
              current_item_exist_in_last_5_items = false;

          if (current_page_number <= 5) {
            current_item_exist_in_first_5_items = true
          } else {
            if ((max_page_number - current_page_number) <=  4) {
            current_item_exist_in_last_5_items = true;
            }
          }

          if (current_item_exist_in_first_5_items == true && current_item_exist_in_last_5_items == false) {

            let last_li = pagination_items[max_page_number-1];
            last_li.parentNode.insertBefore(dots, last_li);
            document.querySelector('[data-page-number="'+(max_page_number)+'"]').classList.add('is_active');

            pagination_items.forEach((item, index) => {
              if (index <= 4) {
                item.classList.add('is_active');
              }
            });

          } else if (current_item_exist_in_first_5_items == false && current_item_exist_in_last_5_items == true) {

              let second_li = pagination_items[1];
              second_li.parentNode.insertBefore(dots, second_li);
              document.querySelector('[data-page-number="1"]').classList.add('is_active');

              for (let i = 0; i <= 4; i++) {
                let item = document.querySelector('[data-page-number="'+(max_page_number-i)+'"]');
                if (item) {
                  item.classList.add('is_active');
                };
              }

          } else if (current_item_exist_in_first_5_items == false && current_item_exist_in_last_5_items == false) {
          
            for (let i = 0; i < 4; i++) {
              let item = document.querySelector('[data-page-number="'+(current_page_number-i)+'"]');
              if (item) {
                item.classList.add('is_active');
              };
            }

            for (let i = 0; i < 4; i++) {
              let item = document.querySelector('[data-page-number="'+(current_page_number+i)+'"]');
              if (item) {
                item.classList.add('is_active');
              };
            }

          }

        } else {

          pagination_items.forEach(item => {
            item.classList.add('is_active');
          });
          
        }
      }

      if (
        current_page_number != 1 && current_page_number != max_page_number || 
        current_page_number == max_page_number
      ) {
        window.blogsPagination.displayPrevArrow(current_page_number - 1);
      } 

      if (current_page_number != max_page_number) {
        window.blogsPagination.displayNextArrow(current_page_number + 1);
      } 

    },

    displayPrevArrow: (id) => {
      let arrow = document.querySelector('.main-blog .blog .pagination-prev-btn');
      if (arrow) {
        let url = arrow.getAttribute('href');
        arrow.setAttribute('href', url+'?page='+id+'&view=blogs');
        arrow.closest('li').classList.add('is_active');
      }
    },

    displayNextArrow: (id) => {
      let arrow = document.querySelector('.main-blog .blog .pagination-next-btn');
      if (arrow) {
        let url = arrow.getAttribute('href');
        arrow.setAttribute('href', url+'?page='+id+'&view=blogs');
        arrow.closest('li').classList.add('is_active');
      }
    }
  
  }

})(window, window.document);

document.addEventListener('DOMContentLoaded', () => {
  window.blogsPagination.init();
});
